import { reactive } from 'vue'

interface LoggerState {
  visible: boolean
  personId?: string
  organizationId?: string
  direction: 'incoming' | 'outgoing'
  onSubmitted?: () => void
}

const state = reactive<LoggerState>({
  visible: false,
  personId: undefined,
  organizationId: undefined,
  direction: 'outgoing',
  onSubmitted: undefined,
})

export function useCallLogger() {
  function openLogger(options: Partial<LoggerState>) {
    Object.assign(state, {
      visible: true,
      direction: 'outgoing',
      ...options,
    })
  }

  function closeLogger() {
    state.visible = false
    state.personId = undefined
    state.organizationId = undefined
    state.direction = 'outgoing'
    state.onSubmitted = undefined
  }

  return {
    openLogger,
    closeLogger,
    loggerState: state,
  }
}

export const loggerState = state
